import { BackendToken, PoolToken, Token, ASSETS, BACKEND_ASSETS } from './interfaces/Token';

export { ASSETS, BACKEND_ASSETS };

export const ADDRESS_CHAR_LENGTH = 66;

export const DEBOUNCE_IN_MS = 500;
export const DEFAULT_DEBOUNCE_INTERVAL_IN_MS = 500;

export const POLLING_INTERVAL_IN_MS = 2 * 60 * 1000;
export const SWAP_POLLING_INTERVAL_IN_MS = 60 * 1000;
export const QUOTE_POLLING_INTERVAL_IN_MS = 15 * 1000;
export const QUOTE_MAX_AGE_IN_MS = 20 * 1000;

export const HEALTH_FACTOR_INFINITY = 9999;
export const HEALTH_FACTOR_WARNING = 1.5;
export const HEALTH_FACTOR_DANGER = 1.2;
export const HEALTH_FACTOR_LIQUIDATION = 1;
export const HEALTH_FACTOR_BUFFER = 0.005;

export const GAS_FEE_UI_DECIMALS = 4;
export const GAS_FEE_PRECISION = 18;

export const MULTICALL_CONTRACT_ADDRESS = '0x05754af3760f3356da99aea5c3ec39ccac7783d925a19666ebbeca58ff0087f4';
export const REFERRAL_EMITTER_CONTRACT_ADDRESS = '0x05ae69ce56bf7ac6bd3df1f9f4a3836f5bf4ff0596db93361dc901c8ff4f7796';
export const AVNU_EXCHANGE_CONTRACT_ADDRESS = '0x04270219d365d6b017231b52e92b3fb5d7c8378b05e9abc97724537a80e93b0f';

export const NOSTRA_HOMEPAGE_URL = 'https://nostra.finance';

export const TRANSACTION_HISTORY_PAGE_SIZES = [7, 10, 15, 20, 30];

export const STABLECOIN_ASSETS = ['DAI', 'DAIv0', 'USDC.e', 'USDT', 'UNO'];
export const VOLATILE_ASSETS = ['WBTC', 'ETH', 'LORDS', 'wstETH', 'NSTR', 'STRK', 'nstSTRK', 'xSTRK', 'EKUBO'];

export const PRICE_PRECISION = 8;
export const USD_UI_PRECISION = 2;
export const PERCENTAGE_UI_PRECISION = 2;

export const ANALYTICS_START_TIMESTAMP = 1697500800;

export const USER_POINTS_PRECISION = 18;
export const REWARDS_PRECISION = 18;

export const AVNU_PUBLIC_KEY =
  '0x0404a04c92ce2e8b79a05424b916ca7fdc4a0b0e026f35cef9601fc1426865d8ee02ee8d2fa5191b03df54f5dd0fb9bda6923329456ada5077cbc54126101c1047';

export const POOL_LP_TOKEN_DECIMALS = 18;
export const POOL_SWAP_FEE_DECIMALS = 4;

export const POOL_TOKEN_TO_PRAGMA_PAIR_ID_MAP: ReadonlyMap<PoolToken, string> = new Map([
  ['WBTC', '6287680677296296772'],
  ['ETH', '19514442401534788'],
  ['USDC.e', '6148332971638477636'],
  ['USDT', '6148333044652921668'],
  ['LORDS', '1407668255603079598916'],
  ['NSTR', '5643947469983535940'],
  ['STRK', '6004514686061859652'],
  ['DAI', '19212080998863684'],
  ['DAIv0', '19212080998863684'],
  ['wstETH', '412383036120118613857092'],
  ['sSTRK', '1537084272803954643780'],
  ['xSTRK', '1629317993172502401860'],
]);

export const PRAGMA_ORACLE_ADDRESS = '0x2a85bd616f912537c50a49a4076db02c00b29b2cdc8a197ce92ed1837fa875b';

export const BACKEND_TOKEN_MAP: Record<BackendToken, Token> = {
  WBTC: 'WBTC',
  ETH: 'ETH',
  DAIv1: 'DAI',
  USDC: 'USDC.e',
  USDT: 'USDT',
  LORDS: 'LORDS',
  WSTETH: 'wstETH',
  NSTR: 'NSTR',
  STRK: 'STRK',
  nstSTRK: 'nstSTRK',
  xSTRK: 'xSTRK',
  sSTRK: 'sSTRK',
  EKUBO: 'EKUBO',
  UNO: 'UNO',
  DAI: 'DAIv0',
};

export const FAVOURITE_TOKENS: string[] = ['NSTR', 'STRK', 'ETH', 'WBTC', 'UNO', 'USDC.e', 'USDC', 'USDT'];

export const STRK_ADDRESS = '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d';

export const CLAIM_BUFFER_IN_MS = 36 * 60 * 60 * 1000;
